import React, { useState, useEffect, useRef } from "react";
import { Input, Dropdown } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import "./AddressInput.scss";

const AddressInput = ({ value, onChange, onSelect, ...props }) => {
  const [address, setAddress] = useState(value?.address ?? "");
  const [valid, setValid] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    setAddress(value?.address);
    if (value?.latLng?.lat && value?.latLng?.lng) setValid(true);
  }, [value]);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const onChangeAddress = newAddress => {
    setAddress(newAddress);
    setValid(false);
    onChange && onChange({ address: newAddress, latLng: { lat: null, lng: null } });
  };

  const onSelectAddress = newAddress => {
    if (!mountedRef.current) return;
    setAddress(newAddress);
    setValid(true);
    geocodeByAddress(newAddress)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        onSelect && onSelect({ address: newAddress, latLng });
      });
  };

  return (
    <PlacesAutocomplete value={address || ""} onChange={onChangeAddress} onSelect={onSelectAddress}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
        const menuItems = suggestions.map((suggestion, index) => {
          const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
          const style = suggestion.active
            ? {
                backgroundColor: "#fafafa",
                cursor: "pointer",
              }
            : {
                backgroundColor: "#ffffff",
                cursor: "pointer",
              };
          return {
            key: index,
            label: (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
                key={suggestion.description}>
                <span>{suggestion.description}</span>
              </div>
            ),
          };
        });

        return (
          <div>
            <Dropdown
              menu={{ items: menuItems }}
              placement="bottomLeft"
              open={suggestions.length > 0}
              destroyPopupOnHide={true}>
              <Input
                {...getInputProps()}
                value={address}
                autoComplete="no"
                suffix={valid && address ? <CheckCircleFilled style={{ color: "#43C1C2" }} /> : ""}
                {...props}
              />
            </Dropdown>
            <div className="autocomplete-dropdown-container">{loading && <div>Loading...</div>}</div>
          </div>
        );
      }}
    </PlacesAutocomplete>
  );
};

export default AddressInput;
